import { makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore";

export enum SectionState {
  initial,
  expanded,
  collapsed,
}
export class SectionStore {
  dateTimeSectionState: SectionState = SectionState.initial;
  circleSectionState: SectionState = SectionState.initial;
  paymentState: SectionState = SectionState.initial;

  // Reset all section states to their initial values
  resetStore = () => {
    this.dateTimeSectionState = SectionState.initial;
    this.circleSectionState = SectionState.initial;
    this.paymentState = SectionState.initial;
  };

  // expandedSection: BookCourtSectionEnum = BookCourtSectionEnum.dateTimeSection;
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  onDateTimeDone() {
    this.setDateTimeSectionState(SectionState.collapsed);
    this.setCircleSectionState(SectionState.expanded);
    this.setPaymentState(SectionState.collapsed);
  }

  onDateTimeEdit() {
    this.setDateTimeSectionState(SectionState.expanded);
    this.setCircleSectionState(SectionState.collapsed);
    this.setPaymentState(SectionState.collapsed);
  }

  onExpandSelectCircle() {
    this.setDateTimeSectionState(SectionState.collapsed);
    this.setCircleSectionState(SectionState.expanded);
    this.setPaymentState(SectionState.collapsed);
  }

  onExpandPaymentSection() {
    this.setDateTimeSectionState(SectionState.collapsed);
    this.setCircleSectionState(SectionState.collapsed);
    this.setPaymentState(SectionState.expanded);
  }

  setDateTimeSectionState = (state: SectionState) => {
    this.dateTimeSectionState = state;
  };
  setCircleSectionState = (state: SectionState) => {
    this.circleSectionState = state;
  };
  setPaymentState = (state: SectionState) => {
    this.paymentState = state;
  };
}
